import React from 'react';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--bg-primary, #f1f5f9)', padding: 40, textAlign: 'center'
        }}>
          <div style={{ maxWidth: 460 }}>
            <div style={{
              width: 72, height: 72, borderRadius: '50%', background: 'rgba(239,68,68,0.08)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px'
            }}>
              <FiAlertTriangle size={32} color="#dc2626" />
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700, color: 'var(--text-primary, #1e293b)' }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: 14, color: 'var(--text-secondary, #64748b)', lineHeight: 1.6, margin: '0 0 24px' }}>
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button onClick={() => window.location.reload()} style={{
              padding: '12px 24px', borderRadius: 10, border: 'none', background: '#2563eb',
              color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', gap: 8,
              boxShadow: '0 4px 12px rgba(37,99,235,0.3)'
            }}>
              <FiRefreshCw size={16} /> Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
